import React from "react";

export default function Home() {
    return (
        <>
        <div className="links-list">
            <h1>
                <a href="https://ecomfrontend-nick.vercel.app/" target="#">
                    Ecommerce Website
                </a>
            </h1>
            <h1>
                <a href="https://jade-kelpie-d2680a.netlify.app/tiles" target="#">
                    Tiles Game
                </a>
            </h1>
        </div>
        </>
    );
};
